import { useCallback, useEffect, useState } from "react";

export const useDebounce = (handler: () => void, debounceMs: number) => {
  useEffect(
    () => {
      const timeout = setTimeout(handler, debounceMs);
      return () => clearTimeout(timeout);
    },
    [debounceMs, handler],
  );
};

export const useDebounced = <T>(value: T, debounceMs: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const handler = useCallback(() => setDebouncedValue(value), [value]);
  useDebounce(handler, debounceMs);
  return debouncedValue;
};
